import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { ROUTESPATH } from "@core/config/constants";
import { TokenService } from "@services/generic/token.service";

@Injectable({
  providedIn: "root",
})
export class PublicGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    if (TokenService.getTokenAC, TokenService.getTokenC) {
      this.router.navigate([ROUTESPATH.HOME]);
      return false;
    } else {
      return true;
    }
  }
}
